// extracted by css-extract-rspack-plugin
export default {"appStoreIcon":"_92b0492b"};